import React from "react";
import style from "../Style.module.css";

const Pattern6 = ({ color = "#2F2F2F", width = "100%", height = "100%" }) => {
  return (
    <svg
      className={style.svgBackground}
      width={width}
      height={height}
      viewBox="10 0 292 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M234.018 78C234.018 34.9218 199.105 0 156.037 0C112.969 0 78.0552 34.9218 78.0552 78C78.0552 121.078 112.969 156 156.037 156C199.105 156 234.018 121.078 234.018 78Z"
        fill={color}
        opacity={0.1}
      />
      <path
        d="M0 78C0 121.113 34.9522 156 77.9816 156L77.9816 78L77.9816 0C34.9522 0 0 34.887 0 78Z"
        fill={color}
        opacity={0.1}
      />
      <path
        d="M234.018 156C277.121 156 312 121.04 312 78C312 34.887 277.048 0 234.018 0L234.018 78L234.018 156Z"
        fill={color}
        opacity={0.1}
      />
    </svg>
  );
};

export default Pattern6;
